// extracted by mini-css-extract-plugin
export default {"detail":"detail_detail__WqbLh","top":"detail_top__pSnrv","pic":"detail_pic__8W69Q","name":"detail_name__M9flG","pictures":"detail_pictures__gY0VD","gender":"detail_gender__Votfc"};